import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import { api } from '../api';
import LoadingOverlay from '../components/LoadingOverlay';

const ApiLoadingContext = createContext(null);
const SHOW_DELAY_MS = 300; // Avoid brief flash for fast requests

export function ApiLoadingProvider({ children }) {
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const timerRef = useRef(null);
  const loadingRef = useRef(false);

  useEffect(() => {
    api.setLoadingListener((isLoading) => {
      loadingRef.current = isLoading;
      setLoading(isLoading);
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      if (isLoading) {
        timerRef.current = setTimeout(() => {
          if (loadingRef.current) setVisible(true);
        }, SHOW_DELAY_MS);
      } else {
        setVisible(false);
      }
    });
    return () => {
      api.setLoadingListener(null);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return (
    <ApiLoadingContext.Provider value={{ loading }}>
      {children}
      <LoadingOverlay visible={visible} />
    </ApiLoadingContext.Provider>
  );
}

export function useApiLoading() {
  const ctx = useContext(ApiLoadingContext);
  return ctx?.loading ?? false;
}
